import React              from 'react';
import { useTranslation } from 'react-i18next';

import Button    from '@mui/material/Button';
import Grid      from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import isBlank from 'utils/isBlank';

import PropTypes from 'prop-types';


export default function MassActivateCardsForm(props) {

  const { t } = useTranslation();

  const [cardGroupId, setCardGroupId] = React.useState('');

  const [fieldErrors, setFieldErrors] = React.useState({});

  function onSubmitPressed() {
    const requiredValidator = (val) => {
      if (isBlank(val)) {
        return t('fieldRequired');
      }
    }

    const validators = {
      default: [],
      cardGroupId: [requiredValidator],
    };

    const toBeSubmitted = {
      cardGroupId: cardGroupId,
    };

    let allValid = true;
    const invalidFields = {};

    for (const key in toBeSubmitted) {
      const fieldValidators = validators[key] || validators.default;
      if (fieldValidators.length === 0) {
        continue; //No validation
      }

      for (const i in fieldValidators) {
        const validator = fieldValidators[i];
        const errMsg = validator(toBeSubmitted[key]);
        if (errMsg) {
          allValid = false;
          invalidFields[key] = errMsg;
          break;
        }
      }
    }
    setFieldErrors(invalidFields);
    if (!allValid)
      return;

    props.onSubmit(toBeSubmitted);
  }

  function commonProps(fieldName, notRequired) {
    function clearError() {
      setFieldErrors(prevState => {
        const newState = { ...prevState };
        delete newState[fieldName];
        return newState;
      });
    }

    return {
      required:   !notRequired,
      error:      !!fieldErrors[fieldName],
      helperText: fieldErrors[fieldName] || ' ',
      onFocus:    clearError,
      disabled:   props.disabled,
    };
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={2}/>
      <Grid item xs={8} align='center' justify='center'>
        {t('massActivateCardsFormDesc')}
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          value={cardGroupId}
          label={t('cardGroupId')}
          onChange={evt => setCardGroupId(evt.target.value)}
          {...commonProps('cardGroupId')}
        />
      </Grid>
      <Grid item xs={12}>
        <Button onClick={onSubmitPressed} disabled={props.disabled}>
          {t('massActivateCardsFormButton')}
        </Button>
      </Grid>
    </Grid>
  );
}

MassActivateCardsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
};
